<template>
  <div>
    <div v-for="(group,j) in list" :key="j">
      <div class="text-center text-gray-100 font-bold">{{group.key}}</div>
      <div class="flex flex-wrap">
        <div v-for="(cls,k) in group.value" :key="k" class="m-1 flex-grow">
          <VPill :text="cls" :selected="isClassSelected(cls)" @click="addClass(cls)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { UiTabs } from "../../util";

export default {
  name: "VClassPanel",
  props: {
    list: { default: [] },
    level: { default: 2 }
  },
  data() {
    return {
      tabs: new UiTabs(["Tags", "Classes"])
    };
  },
  mounted() {
    this.tabs.select("Tags");
  },
  computed: {
    ...mapGetters([
      "selectedNodeClassList",
      "selectedNodeParents",
      "isSelectedNode",
      "isClassSelected"
    ])
  },
  methods: {
    ...mapActions(["addClass", "deleteNode", "selectNode"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.t-col {
  color: rgb(224, 227, 230);
}
.bg-tag {
  background: rgb(62, 61, 61);
}
.triangle {
  height: 0;
  width: 0;
  margin-left: -1px;
  border-left: 9px solid rgb(62, 61, 61);
  border-right: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-top: 9px solid transparent;
}
</style>
